import de from './de'
import en from './en'
import fr from './fr'

const locales = { de, en, fr }

window._availableLocales = Object.fromEntries(Object.entries(locales).map(([key, messages]) => [key, messages._localeName || key]))

export default locales
